import { render, staticRenderFns } from "./AddWorkPlaceDialog.vue?vue&type=template&id=315ba76d&"
import script from "./AddWorkPlaceDialog.vue?vue&type=script&lang=js&"
export * from "./AddWorkPlaceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports